import React, { useEffect, useState } from "react";
import { BtnGravar, BtnSair } from "./Buttons";
import { LoadingContainerPadrao, ModalPadrao, TextAreaPadrao } from "./Base";

export default function ModalCancelamentoPadrao({ loading, visible, onOk, onCancel, title, children }) {
  const [text, setText] = useState(null);

  useEffect(() => {
    if (!!visible)
      setText(null);
  }, [visible]);

  return <ModalPadrao title={title} visible={visible} footer={<>
    <BtnGravar onClick={() => onOk(text)} disabled={loading} />
    <BtnSair onClick={onCancel} />
  </>} onCancel={onCancel}>
    <LoadingContainerPadrao loading={loading}>
      <TextAreaPadrao placeholder="Insira o motivo" value={text} onChange={v => setText(v.target.value)} autoFocus />
      {children}
    </LoadingContainerPadrao>
  </ModalPadrao>;
}